import React, { useState } from 'react';
import { useQuery } from 'react-query';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';

import { fetchMonitoringBonsLivraison } from 'utils/ts-queries';
import { MonitoringBonsLivraison } from 'types/monitoringBonsLivraison';
import MonitoringBonLivraisonRow from './MonitoringBonLivraisonRow';

const NB_PAR_PAGE = 50;

function AdministrationMonitoringBonsLivraison() {
    const [page, setPage] = useState(0);

    const blQuery = useQuery<MonitoringBonsLivraison>(
        ['monitoringBonsLivraison', page],
        () => fetchMonitoringBonsLivraison(page, NB_PAR_PAGE),
        { refetchOnWindowFocus: false, keepPreviousData: true }
    );

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" sx={{ mb: 1 }}>Monitoring des bons de livraison</Typography>
            <Alert severity="info" sx={{ mb: 2 }}>
                Bons de livraison de gestion (BonLivraisonGestion) sans commande de gestion correspondante
                (BL.NumeroPiece = Commande.Cle) alors qu'elle devrait exister — statuts Annulé et Ordonnancement exclus.
            </Alert>

            <Paper sx={{ p: 1 }}>
                {blQuery.isLoading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>
                )}
                {blQuery.isError && (
                    <Alert severity="error">Erreur de chargement des bons de livraison.</Alert>
                )}
                {blQuery.data && (
                    <>
                        <Typography variant="subtitle2" sx={{ p: 1 }}>
                            {blQuery.data.nbTotal}{blQuery.data.totalPlafonne ? '+' : ''} bon(s) de livraison sans commande correspondante
                        </Typography>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Clé BL</TableCell>
                                    <TableCell>Numéro pièce (commande attendue)</TableCell>
                                    <TableCell>Statut</TableCell>
                                    <TableCell>Dépôt départ</TableCell>
                                    <TableCell>Intégration</TableCell>
                                    <TableCell align="right">JSON</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {blQuery.data.bonsLivraison.map(bl => (
                                    <MonitoringBonLivraisonRow key={bl.cle} bl={bl} />
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            count={blQuery.data.nbTotal}
                            page={page}
                            onPageChange={(_e, p) => setPage(p)}
                            rowsPerPage={NB_PAR_PAGE}
                            rowsPerPageOptions={[NB_PAR_PAGE]}
                            labelDisplayedRows={({ from, to, count }) =>
                                `${from}–${to} sur ${count}${blQuery.data?.totalPlafonne ? '+' : ''}`}
                        />
                    </>
                )}
            </Paper>
        </Box>
    );
}

export default AdministrationMonitoringBonsLivraison;
